import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { Calendar } from 'react-date-range';
import './style.scss';

interface Props {
    initialDate: Date | undefined;
    color: string;
    locale: Locale;
    maxDate: Date | undefined;
    minDate: Date | undefined;
    onChange: CallableFunction;
    onHide: CallableFunction;
    weekdayDisplayFormat: string;
    show: boolean;
    title: string;
}

const DatePicker: React.FC<Props> = (props: Props) => {
    const { initialDate, color, locale, maxDate, minDate, onChange, onHide, weekdayDisplayFormat, show, title } = props;

    return (
        <Modal centered dialogClassName="class-form-date-picker" id="date-picker-modal" onHide={() => onHide()} show={show}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Calendar
                    color={color}
                    date={initialDate}
                    locale={locale}
                    maxDate={maxDate}
                    minDate={minDate}
                    onChange={onChange}
                    weekdayDisplayFormat={weekdayDisplayFormat}
                />
            </Modal.Body>
        </Modal>
    );
};

export default React.memo(DatePicker);
